//* /um-vr/felagsgjald-og-adild/ dropdown of months which returns that months fees

const MembershipFees = (target) => {
  const method = {
    init: () => {
      if (target) {
        const select = target.querySelector(".js-membership--fees__select");
        const form = target.querySelector("#form_vr_fees");
        select.addEventListener("change", (e) => {
          e.preventDefault();
          method.change(target, form);
        });
      }
    },

    change: async (target, form) => {
      const loader = target.querySelector(".loader");
      const data = new FormData(form);
      const action = form.getAttribute("action");
      const formMethod = form.getAttribute("method");

      loader.style.display = "block";

      fetch(action, {
        method: formMethod,
        body: data,
      })
        .then(res => res.json())
        .then((response) => {
          method.renderMessage(response.message);
          setTimeout(() => {
            loader.removeAttribute("style");
          }, 150);
        })
        .catch((ex) => {
          console.log(ex);
          method.renderMessage(`Server error: ${ex}`);
        });
    },

    renderMessage: (message) => {
      const result = target.querySelector(".membership--fees__results");
      result.innerHTML = message;
    },
  };

  method.init();
};

export default MembershipFees;
